import { useState, useEffect, useContext, useRef } from "react";
import {
  fetchTasks,
  deleteTask,
  createTask,
  patchTask,
  fetchData,
} from "../api";
import EditTaskModal from "./Modals/EditTaskModal/EditTaskModal";
import styles from "./TaskList.module.scss";
import modStyles from "../styles/modulars.module.scss";
import { images_path } from "../constants";
import { AppContext } from "../AppContext";
import ConfirmationBoxModal from "./Modals/ConfirmationBoxModal";
import { formatDateNumeric, getTaskModel } from "../utils/dbUtils";
import React from "react";
import { HomeContext } from "../pages/Home";

function TaskList({ updateCounter, setUpdateCounter, advFilter }) {
  const [loading, setLoading] = useState(true);
  const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [taskToDelete, setTaskToDelete] = useState(null);

  const editTask = useRef(null);

  const [nameFilter, setNameFilter] = useState("");
  const [workflowFilter, setWorkflowFilter] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("");
  const [descriptionFilter, setDescriptionFilter] = useState("");
  const [hoursWorkedFilter, setHoursWorkedFilter] = useState("");
  const [hoursEstimatedFilter, setHoursEstimatedFilter] = useState("");
  const [usersFilter, setUsersFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [clientFilter, setClientFilter] = useState("");
  const [createdAtFilter, setCreatedAtFilter] = useState("");
  const [updatedAtFilter, setUpdatedAtFilter] = useState("");

  const [filteredTasks, setFilteredTasks] = useState(null);

  const {
    user,
    userCategories,
    tasks,
    setTasks,
    setTasksQueryData,
    statusDict,
  } = useContext(AppContext);
  const { displayedTasksValues } = useContext(HomeContext);
  const isFirstRender = useRef(true);

  const displayStd = (obj, values) => {
    let displayValue = obj[values[0]];
    if (values.length > 1) {
      values.map((value, idx) => {
        if (!displayValue) return "";
        if (idx !== 0) {
          displayValue = displayValue[value];
        }
      });
    }
    return displayValue;
  };

  const displayFnameLname = (task, values) => {
    let users = task[values[0]];
    let displayValue = "";
    users.map((user, idx) => {
      displayValue += user.first_name + " " + user.last_name + ", ";
      if (idx === users.length - 1) displayValue = displayValue.slice(0, -2);
    });

    return displayValue;
  };

  const displayHours = (task, values) => {
    let displayValue = 0;
    const worklogs = task[values[0]];
    worklogs.map((log) => {
      if (log.user === user.id) {
        displayValue += log.hours_worked;
        return;
      }
    });
    return displayValue;
  };

  const displayStatus = (task, values) => {
    return statusDict[task[values[0]]];
  };

  const displayTime = (task, values) => {
    return formatDateNumeric(task[values[0]]);
  };

  const displayUserData = (task, values) => {
    const userData = task.user_data.find((data) => data.user === user.id);
    return userData ? displayStd(userData, values) : "";
  };

  const tableHeaders = [
    {
      name: "Commessa",
      fields: ["name"],
      displayMethod: displayStd,
      filter: nameFilter,
      setFilter: setNameFilter,
    },
    {
      name: "Workflow",
      fields: ["workflow"],
      displayMethod: displayStd,
      filter: workflowFilter,
      setFilter: setWorkflowFilter,
    },
    {
      name: "Categoria",
      fields: ["category", "name"],
      displayMethod: displayStd,
      filter: categoryFilter,
      setFilter: setCategoryFilter,
    },
    {
      name: "Descrizione",
      fields: ["description"],
      displayMethod: displayStd,
      filter: descriptionFilter,
      setFilter: setDescriptionFilter,
    },
    {
      name: "Ore",
      fields: ["worklogs", "hours_worked"],
      displayMethod: displayHours,
      filter: hoursWorkedFilter,
      setFilter: setHoursWorkedFilter,
    },
    {
      name: "Stima",
      fields: ["hours_estimated"],
      filter: hoursEstimatedFilter,
      setFilter: setHoursEstimatedFilter,
      displayMethod: displayStd,
    },
    {
      name: "Utenti",
      fields: ["assigned_users"],
      displayMethod: displayFnameLname,
      filter: usersFilter,
      setFilter: setUsersFilter,
    },
    {
      name: "Status",
      fields: ["status"],
      displayMethod: displayStatus,
      filter: statusFilter,
      setFilter: setStatusFilter,
    },
    {
      name: "Cliente",
      fields: ["offer", "client_name"],
      displayMethod: displayStd,
      filter: clientFilter,
      setFilter: setClientFilter,
    },
    {
      name: "Data Creazione",
      fields: ["created_at"],
      displayMethod: displayTime,
      filter: createdAtFilter,
      setFilter: setCreatedAtFilter,
    },
    {
      name: "Ultima Modifica",
      fields: ["updated_at"],
      displayMethod: displayTime,
      filter: updatedAtFilter,
      setFilter: setUpdatedAtFilter,
    },
  ];

  const filterTasks = (taskList) => {
    taskList = taskList ? taskList : tasks;
    let tasksToFilter = [...taskList];
    tableHeaders.map((header) => {
      if (header.filter != "") {
        tasksToFilter = tasksToFilter.filter((task) => {
          return header
            .displayMethod(task, header.fields)
            ?.toString()
            ?.toLowerCase()
            ?.includes(header.filter.toLowerCase());
        });
      }
    });
    setFilteredTasks(tasksToFilter);
  };

  const reloadPage = () => {
    fetchTasks(advFilter).then((fetchedTasks) => {
      setTasks(fetchedTasks.results);
      setTasksQueryData(fetchedTasks);
      setFilteredTasks(fetchedTasks.results);
      filterTasks(fetchedTasks.results);
      setLoading(false);
    });
  };

  useEffect(() => {
    // setLoading(true);
    if (isFirstRender.current) {
      return;
    }
    reloadPage();
  }, [updateCounter]);

  useEffect(
    () => {
      if (isFirstRender.current) {
        isFirstRender.current = false;
        return;
      }
      filterTasks();
    },
    tableHeaders.map((header) => header.filter)
  );

  if (loading) {
    return <div>Loading...</div>;
  }

  const handleDelete = async () => {
    await deleteTask(taskToDelete);
    setUpdateCounter(updateCounter + 1);
  };

  const handleEdit = (task) => {
    editTask.current = task;
    setIsTaskModalOpen(true);
  };

  const handleAdd = async () => {
    if (userCategories.length === 0) return;

    editTask.current = null;
    const newTask = getTaskModel({
      taskName: null,
      description: "",
      category: userCategories[0].id,
      user_data: [{ user: user.id }],
      comments: [],
    });
    const createdTask = await createTask(newTask);
    setUpdateCounter(updateCounter + 1);
    fetchTasks({ task_id: createdTask.id }).then((fetchedTasks) => {
      editTask.current = fetchedTasks.results[0];
      setIsTaskModalOpen(true);
    });
  };

  const TaskTableHeaders = () => {
    return (
      <div className={styles.headers_table}>
        {tableHeaders.map((header, idx) => {
          return (
            <div className={styles.header_cell} key={idx}>
              <span className={styles.table_header}>{header.name}</span>
              <button className={styles.sort_button}>
                <img src={images_path + "down_arrow_thick.svg"}></img>
              </button>
            </div>
          );
        })}
      </div>
    );
  };

  const getTaskTableInputs = () => {
    return (
      <div className={styles.headers_table}>
        {tableHeaders.map((header, idx) => {
          return (
            <div className={styles.input_cell} key={idx}>
              <input
                value={header.filter}
                onChange={(e) => {
                  header.setFilter(e.target.value);
                }}
                className={styles.filter_input}
              ></input>
            </div>
          );
        })}
      </div>
    );
  };

  const TaskTableButtons = () => {
    return (
      <div className={styles.icons_table}>
        {filteredTasks.map((task, taskIdx) => {
          return (
            <div key={task.id} className={styles.icon_container}>
              <button
                className={modStyles.tr_btn + " " + styles.icon_button}
                onClick={() => {
                  setIsDeleteModalOpen(true);
                  setTaskToDelete(task.id);
                }}
              >
                <img
                  className={styles.icon}
                  src={images_path + "delete_task.svg"}
                ></img>
              </button>
              <button
                onClick={() => handleEdit(task)}
                className={modStyles.tr_btn + " " + styles.icon_button}
              >
                <img
                  className={styles.icon}
                  src={images_path + "edit_task.svg"}
                ></img>
              </button>
              {/* {!task.completed ? (
                <button
                  title="Chiudi commessa"
                  onClick={() => {
                    patchTask(task.id, { completed: true }).then(() => {
                      setUpdateCounter(updateCounter + 1);
                    });
                  }}
                  className={modStyles.tr_btn + " " + styles.icon_button}
                >
                  <img
                    className={styles.icon}
                    src={images_path + "archive.svg"}
                  ></img>
                </button>
              ) : (
                <button
                  title="Apri commessa"
                  onClick={() => {
                    patchTask(task.id, { completed: false }).then(() => {
                      setUpdateCounter(updateCounter + 1);
                    });
                  }}
                  className={modStyles.tr_btn + " " + styles.icon_button}
                >
                  <img
                    className={styles.icon}
                    src={images_path + "unarchive.svg"}
                  ></img>
                </button>
              )} */}
            </div>
          );
        })}
      </div>
    );
  };

  const TaskTableValues = () => {
    const tempDisplayedTasksValues = [];
    tempDisplayedTasksValues.push(
      Object.values(tableHeaders).map((header) => header.name)
    );
    return (
      <div className={styles.values_table}>
        {filteredTasks.map((task, taskIdx) => {
          let hoursWorked = null;
          task.user_data.map((data) => {
            if (data.user === user.id) {
              hoursWorked = data.hours_worked;
            }
          });

          const cellStyle = styles.table_cell;

          const displayedTaskValues = [];
          tableHeaders.map((header) => {
            displayedTaskValues.push(header.displayMethod(task, header.fields));
          });
          tempDisplayedTasksValues.push(displayedTaskValues);
          if (taskIdx >= filteredTasks.length - 1) {
            displayedTasksValues.current = [...tempDisplayedTasksValues];
          }

          return (
            <React.Fragment key={task.id}>
              {displayedTaskValues.map((displayValue, idx) => {
                return (
                  <div className={cellStyle} key={idx}>
                    {displayValue}
                  </div>
                );
              })}
            </React.Fragment>
          );
        })}
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.whole_table}>
        <TaskTableHeaders />

        {getTaskTableInputs()}
        <button className={styles.add_button} onClick={handleAdd}>
          + Nuova commessa
        </button>
        <TaskTableButtons />
        <TaskTableValues />
      </div>
      <EditTaskModal
        isOpen={isTaskModalOpen}
        onClose={() => {
          setIsTaskModalOpen(false);
          setUpdateCounter(updateCounter + 1);
        }}
        onUpdate={() => {
          setUpdateCounter(updateCounter + 1);
        }}
        editTask={editTask.current}
      />
      <ConfirmationBoxModal
        text="Eliminare commessa?"
        isOpen={isDeleteModalOpen}
        onClose={() => {
          setIsDeleteModalOpen(false);
          editTask.current = null;
        }}
        onConfirm={handleDelete}
      />
    </div>
  );
}

export default TaskList;
